

export type BillingServiceConfig = {
	site: string;
	publishableKey: string;
};
export class BillingService {
	readonly #config: Readonly<BillingServiceConfig>;
	#chargebeeInstance: Chargebee.Instance | null = null;

	constructor(config: BillingServiceConfig) {
		this.#config = Object.freeze({ site: config.site, publishableKey: config.publishableKey });
	}

	async initialiseChargebee(): Promise<void> {
		if(this.#chargebeeInstance) {
			return;
		}

		this.#chargebeeInstance = Chargebee.init({ ...this.#config });
		await this.#chargebeeInstance.load("components");
	}


	get chargebeeInstance(): Chargebee.Instance {
		if(!this.#chargebeeInstance) {
			throw new Error("Chargebee was not initialised.");
		}

		return this.#chargebeeInstance;
	}
}